var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLocal)?_c(_vm.localIcon,_vm._g({tag:"component",staticClass:"base-icon local-icon",style:({ '--fill': _vm.fill, width: _vm.width, height: _vm.height })},_vm.$listeners)):_c('div',_vm._g({directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(
        `${_vm.iconUrl}?d=${_vm.width.replace('px', '')}x${_vm.height.replace(
            'px',
            ''
        )}`
    ),expression:"\n        `${iconUrl}?d=${width.replace('px', '')}x${height.replace(\n            'px',\n            ''\n        )}`\n    ",arg:"background-image"}],staticClass:"base-icon",style:({ width: _vm.width, height: _vm.height })},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }